import { giphyLightestGrey, giphyRed } from '@giphy/js-brand'
import React, { useContext, useRef } from 'react'
import {
    DuplicateGradientIcon,
    FlipGradientIcon,
    // PinGradientIcon,
    // FxGradientIcon,
    MenuRemoveIcon,
    SendToBackGradientIcon,
    TimingGradientIcon,
} from 'site/creation-tools/components/icons'
import styled from 'styled-components'
import MenuItem from './menu-item'
import { BORDER_RADIUS_MEDIUM } from 'site/creation-tools/constants'
import { SourceEditorCaption } from 'site/creation-tools/components/source-editor/types'
import { CreationSourceEditorContext } from 'site/creation-tools/components/source-editor/manager'
import CreationToolSourceEditor from 'site/creation-tools/types/source-editor'
import CreationToolOutputType from 'site/creation-tools/types/output-type'
import { useClickAway } from 'react-use'

const Z_INDEX = 999

type ContainerPosition = {
    top?: number
    left?: number
}

type MenuProps = {
    onClickOutside?: () => void
    caption: SourceEditorCaption
} & ContainerPosition

const Container = styled.div<ContainerPosition>`
    position: absolute;
    z-index: ${Z_INDEX};
    top: ${props => props.top}px;
    left: ${props => props.left}px;
`

const Dropdown = styled.div`
    position: relative;
    background: #000;
    border-radius: ${BORDER_RADIUS_MEDIUM}px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
    color: ${giphyLightestGrey};
    font-size: 15px;
    padding: 20px;
    width: 220px;

    &:before {
        border-bottom: 6px solid #000;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        content: '';
        height: 0;
        left: -9px;
        position: absolute;
        width: 0;
        transform: rotate(270deg);
        top: 21px;
    }
`

const Items = styled.div`
    svg {
        transition: opacity 0.15s ease-out;
    }

    &:hover svg {
        opacity: 0.5;
    }

    &:hover > div:hover svg {
        opacity: 1;
    }
`

const Menu = ({ top, left, caption, onClickOutside }: MenuProps) => {
    const ref = useRef(null)
    const { duplicate, flip, sendToBack, deleteCaption, setCurrentEditor, outputType } = useContext(
        CreationSourceEditorContext
    )
    useClickAway(ref, e => {
        const target = e.target as HTMLElement
        if (target.id !== 'ellipsisButton') {
            onClickOutside?.()
        }
    })
    const supportsTimer = outputType === CreationToolOutputType.Gif || outputType === CreationToolOutputType.Sticker

    return (
        <Container top={top} left={left} ref={ref}>
            <Dropdown>
                <Items>
                    {supportsTimer && (
                        <MenuItem label="Timing" onClick={() => setCurrentEditor(CreationToolSourceEditor.Layers)}>
                            <TimingGradientIcon />
                        </MenuItem>
                    )}
                    <MenuItem label={'Duplicate'} onClick={() => duplicate(caption)}>
                        <DuplicateGradientIcon />
                    </MenuItem>
                    <MenuItem label={'Flip / Mirror'} onClick={() => flip(caption)}>
                        <FlipGradientIcon />
                    </MenuItem>
                    <MenuItem label={'Send to Back'} onClick={() => sendToBack(caption)}>
                        <SendToBackGradientIcon />
                    </MenuItem>
                    <MenuItem label={'Delete'} onClick={() => deleteCaption(caption)}>
                        <MenuRemoveIcon colors={[giphyRed]} />
                    </MenuItem>
                    {/* <MenuItem label={'Pin'} onClick={() => {}}>
                        <PinGradientIcon />
                    </MenuItem> */}
                    {/* <MenuItem label={'Fx'} onClick={() => {}}>
                        <FxGradientIcon />
                    </MenuItem> */}
                </Items>
            </Dropdown>
        </Container>
    )
}

export default Menu
